import { ts } from '_core';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.ALPHA_MODEL_TREE_MODELS_IMPORTANCE,
    title: 'Tree Model Signal Importance',
    helpLabel: 'lznupaya',
    form: false,
    neededFiles: ['tree_models_importance'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.RANDOM_FOREST_ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.GRADIENT_BOOSTING_ALPHA_MODEL,
    ],
  },
] satisfies ts.types.analysis.WidgetConfig[];
